var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"proxyip"},[_c('banner',{attrs:{"swiperData":_vm.swiperData,"pagination":false}}),_c('div',{staticClass:"main"},[_c('tabs',{attrs:{"tabsList":_vm.tabsList}}),_c('div',{staticClass:"tabs-content width1534",style:({ 'border-color': _vm.tabsList[_vm.active].color })},[_c('ipFamily',{attrs:{"active":_vm.active}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }